import React from "react";
import "./article.css";

const Article = ({ date, title, image, type }) => {
  return (
    <div className={"gpt3__blog-article " + type}>
      <img
        className="gpt3__blog-articleImage"
        src={image}
        alt="Title of the image"
      />
      <div className="gpt3__blog-articleInfo">
        <div>
          <p>{date}</p>
          <h6>{title}</h6>
        </div>
        <a href="#"> Read Full Article</a>
      </div>
    </div>
  );
};

export default Article;
